module.exports = __webpack_public_path__ + "img/sms-star.08b70c6f.svg";